import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function FailedSolutionsSection() {
  const solutions = [{
    title: "Las 'burbujas de luz'",
    desc: 'Requieren meditación profunda, algo imposible de hacer en medio de una discusión o en una oficina llena de gente.'
  }, {
    title: 'Ignorar el problema',
    desc: 'No lo soluciona; la energía estancada se convierte en síntomas físicos y agotamiento crónico.'
  }, {
    title: 'Los amuletos pasivos',
    desc: 'No son suficientes cuando tu sistema nervioso entra en resonancia con el caos externo.'
  }, {
    title: "Intentar 'caer bien'",
    desc: 'A todo el mundo abre fugas energéticas masivas que te dejan vacío al final del día.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-navy-900" data-id="element-20">
      <div className="max-w-4xl mx-auto" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-22">
          <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-23">
            Por Qué Lo Que Has Intentado No Funciona
          </h2>
          <div className="w-16 h-1 bg-gold-500 mx-auto" data-id="element-24" />
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-25">
          {solutions.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex gap-4 p-6 bg-navy-950/50 rounded-lg border border-red-900/20" data-id="element-26">
              <div className="flex-shrink-0 mt-1" data-id="element-27">
                <div className="w-8 h-8 rounded-full bg-red-900/30 flex items-center justify-center" data-id="element-28">
                  <X className="w-5 h-5 text-red-500" data-id="element-29" />
                </div>
              </div>
              <div data-id="element-30">
                <h3 className="text-white font-serif text-xl mb-2" data-id="element-31">
                  {item.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-32">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}